<template>
  <v-card
    tile
    :elevation="elevation"
    :data-date="formatedDutyDate"
    style="border-bottom: 1px solid rgba(0, 0, 0, .1)"
    @click="goToWorkday(duty)"
  >
    <v-row no-gutters>
      <v-col
        cols="auto"
        class="pl-4 pt-2"
        style="width: 100px"
        :class="[isDutyToDay ? $style.isToday : 'grey lighten-3']"
      >
        <div class="text-capitalize">
          <h4>{{ dutyDate }}</h4>
          <div class="caption">{{ weekday }}</div>
        </div>
      </v-col>
      <v-col class="pa-2 pl-4">
        <v-row no-gutters>
          <v-col class="h5">
            {{ duty.DutyName }}
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <div class="caption" :class="$style.timeContainer">
              <v-icon size="12" class="mr-1 grey--text text--darken-1"
                >mdi-clock-outline</v-icon
              >
              {{ dutyStartTime }} - {{ dutyEndTime }}
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="auto"
        class="d-flex flex-column align-end px-4 justify-center"
        v-if="!isAbsence"
      >
        <v-icon size="24" class="grey--text text">mdi-chevron-right</v-icon>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import svLocale from 'date-fns/locale/sv'
import { format } from 'date-fns'

export default {
  name: 'SchemaListItem',

  props: {
    elevation: {
      type: [String, Number],
      default: () => 0
    },
    duty: Object
  },

  data: () => ({}),

  computed: {
    employeeNumber() {
      return this.$store.get('sso/user').employeenumber
    },

    isDutyToDay() {
      return format(new Date(), 'yyyy-MM-dd') === this.formatedDutyDate
    },

    formatedDutyDate() {
      return format(new Date(this.duty.DutyDate), 'yyyy-MM-dd')
    },

    dutyDate() {
      return format(new Date(this.duty.DutyDate), 'dd MMM', {
        locale: svLocale
      }).replace('.', '')
    },

    weekday() {
      return format(new Date(this.duty.DutyDate), 'cccc', {
        locale: svLocale
      })
    },

    dutyStartTime() {
      return format(new Date(this.duty.DutyStart), 'HH:mm')
    },

    dutyEndTime() {
      return format(new Date(this.duty.DutyEnd), 'HH:mm')
    },

    isAbsence() {
      return false
    }
  },

  methods: {
    goToWorkday(duty) {
      if (this.isAbsence) return
      const dutyDate = format(new Date(duty.DutyDate), 'yyyy-MM-dd')
      const employeeNumber =
        this.$route.params.employeenumber || this.employeeNumber
      this.$router.push(`/workday/${dutyDate}/${employeeNumber}`)
    }
  }
}
</script>

<style module>
.timeContainer {
  display: flex;
  align-items: center;
}

.isToday {
  background-color: #00a14a;
  box-shadow: 0 2px 12px rgba(0, 161, 74, 0.91);
  color: white;
}
</style>
